// src/components/Navbar.jsx

import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../config/AuthProvider';
import { FaClock, FaCalendarAlt, FaSignOutAlt, FaRegCalendarCheck, FaFileInvoiceDollar } from 'react-icons/fa';
import { appConfig } from '../config/appConfig';
import '../css/Navbar.css'; // Provjerite putanju prema vašem CSS fajlu

function Navbar() {
  const { currentUser, isAdmin, logout } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      await logout();
      // Opcionalno: preusmjerite korisnika nakon odjave
    } catch (error) {
      console.error('Greška pri odjavi:', error);
      alert('Došlo je do greške prilikom odjave. Pokušajte ponovno.');
    }
  };

  return (
    <nav className="navbar">
      <span className="navbar-brand" title={appConfig.appTitle}>
        {appConfig.navbarBrand}
      </span>
      <ul>
        {isAdmin ? (
          <>
            <li>
              <NavLink to="/sati" end>
                <FaClock className="nav-icon" />
                <span>Sati</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/obracun">
                <FaFileInvoiceDollar className="nav-icon" />
                <span>Obračun</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/mjesecni-sati">
                <FaCalendarAlt className="nav-icon" />
                <span>Mjesečni sati</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/praznici">
                <FaRegCalendarCheck className="nav-icon" />
                <span>Praznici</span>
              </NavLink>
            </li>
          </>
        ) : currentUser ? (
          <li>
            <NavLink to="/moj-tjedan">
              <FaClock className="nav-icon" />
              <span>Moj tjedan</span>
            </NavLink>
          </li>
        ) : null}
        {currentUser && (
          <li className="logout">
            <button onClick={handleLogout}>
              <FaSignOutAlt className="nav-icon" />
              <span>Odjava</span>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;